module.exports = __webpack_public_path__ + "static/media/instagram-logo.7703e0de.png";